/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["repeat-button,repeat-button>button{display:block}repeat-button .active{color:var(--be-accent-default)}"];
export { styles as styles };
